import { FieldState } from 'formoid';
import { Option, Select, SelectProps } from '~/common/components';
import { Any } from '~/common/utils';

type Props<T extends Option<Any>> = SelectProps<T> & FieldState<T['value'] | null>;

export const SelectField = <T extends Option<Any>>({ touched, ...props }: Props<T>) => (
  <Select {...props} error={props.errors !== null} />
);
